import React from 'react';

import { twMerge } from 'tailwind-merge';

import Checkbox from 'components-new/checkbox/checkbox';
import Typography from 'components-new/typography/typography';

export interface FilterHeadlineItemProps {
  isChecked?: boolean;
  title: string;
  className?: string;
  typographyClassName?: string;
  checkboxClassName?: string;
  onClick?: () => void;
}

export const FilterHeadlineItem: React.FC<FilterHeadlineItemProps> = (
  props,
) => {
  const { isChecked, title } = props;

  const typographyClassNames = twMerge(
    'text-gray700',
    props.typographyClassName,
  );

  return (
    <div
      className={twMerge('flex flex-row gap-x-2 items-center', props.className)}
    >
      <Checkbox
        variant={isChecked ? 'checked' : 'unchecked'}
        className={props.checkboxClassName}
        onClick={props.onClick}
      />
      <Typography className={typographyClassNames} variant="body-medium" as="p">
        {title}
      </Typography>
    </div>
  );
};
